/** @format */

const TableHeader = ({ showActions }) => {
  return (
    <thead className="bg-[#F5F5FF] text-right text-[#404040] cursor-pointer sm:w-16 md:w-32 lg:w-48 text-sm text-black-400 font-Inter">
      <tr>
        <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal border-none">
          No
        </th>
        <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal border-none">
          Name
        </th>
        <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal border-none">
          Date
        </th>
        <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal border-none">
          Analyst
        </th>
        <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal border-none">
          Status
        </th>
        {showActions && (
          <th className="p-1 md:p-2 text-start text-[11px] md:text-sm font-normal border-none text-[#4C4DDC]">
            Action
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;

// const TableHeader = ({ showActions }) => {
//   return (
//     <thead className="bg-[#F5F5FF] text-right text-sm text-black-400 font-Inter">
//       <tr className="hidden md:table-row">
//         <th className="p-2 text-start font-normal border-none">No</th>
//         <th className="p-2 text-start font-normal border-none">Name</th>
//         <th className="p-2 text-start font-normal border-none">Date</th>
//         <th className="p-2 text-start font-normal border-none">Officer</th>
//         <th className="p-2 text-start font-normal border-none">Status</th>
//         {showActions && (
//           <th className="p-2 text-start font-normal border-none text-[#4C4DDC]">
//             Action
//           </th>
//         )}
//       </tr>
//       <tr className="table-row md:hidden">
//         <th className="p-2 text-start font-normal border-none">No</th>
//         <th className="p-2 text-start font-normal border-none">Name</th>
//         <th className="p-2 text-start font-normal border-none">Date</th>
//         <th className="p-2 text-start font-normal border-none">Officer</th>
//         <th className="p-2 text-start font-normal border-none">Status</th>
//         {showActions && (
//           <th className="p-2 text-start font-normal border-none text-[#4C4DDC]">
//             Action
//           </th>
//         )}
//       </tr>
//     </thead>
//   );
// };

// export default TableHeader;
